export default [
    {
        path: '/website/product-sort',
        props: true,
        component: () => import('@/views/WebsiteCatalogRanking'),
    },
    {
        path: '/website/country-priority',
        props: true,
        component: () => import('@/views/WebsiteCatalogRanking/CountryPriority'),
    },
];
